export default __webpack_public_path__ + "static/media/Mobile-App-Illustration2.3853567c.png";